<template>
  <div class="loader">
    <span class="loader__loading"></span>
  </div>
</template>

<style src="./style.less" lang="less"></style>
